module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_woowahan_m.30bdfe21318fa09d01c47b23f673e500.png";